import React from 'react';
import './index.scss';
import store, {history, persistor} from './store';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/lib/integration/react';
import * as serviceWorker from './serviceWorker';
import {Routes} from 'react-router-dom';
import Moment from 'react-moment';
import routes from './routes/routes';
import './i18n';
import {HistoryRouter as Router} from 'redux-first-history/rr6';
import {createRoot} from 'react-dom/client';
import {AccessibilityWrapper} from 'marine-panel-common-web';

Moment.startPooledTimer(1000);
const container = document.getElementById('root');
const root = createRoot(container as any);

root.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <AccessibilityWrapper>
                <Router history={history}>
                    <Routes>{routes}</Routes>
                </Router>
            </AccessibilityWrapper>
        </PersistGate>
    </Provider>
);

serviceWorker.unregister();
